export enum DebtorRelationship {
  OTHER = 'OTHER',
  SPOUSE = 'SPOUSE',
  PARTNER = 'PARTNER'
}
